import React, { JSX } from "react";
import Modal from "../../../../components/modal";
import { Box, Button, TextField } from "@mui/material";
import { ToolbarModal } from "../../../../components/toolbar";
import { Check, Close } from "@mui/icons-material";
import InputCurrency from "../../../../components/fieldCurrency/inputCurrency";

interface BoxModalProps {
    title: string;
    handleClose: () => any;
    show: boolean;
    confirmar: (value: number) => any;
}

function DescontoModal({ handleClose, show, confirmar, title }: BoxModalProps) {


    const handleConfirmar = (desconto:number) => {
        if (desconto > 0) {
            confirmar(desconto);
        }
    }

    const Content = () => {
        const [desconto, setDesconto] = React.useState<number>(0);

        return (
            <div style={{ padding: 10 }}>
                <InputCurrency
                    customInput={TextField}
                    propscustominput={{
                        fullWidth: true,
                        onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                            if (e.key === "Enter") {
                                handleConfirmar(desconto);
                            }
                            if (e.key === "Escape") {
                                handleClose();
                            }
                        },
                        label: "Desconto",
                        variant: "outlined",
                    }}
                    value={desconto}
                    id={"desconto"}
                    name={"desconto"}
                    onChange={(e: any) => {
                        if (e.type === "custom") {
                            let value = e.target.value;
                            setDesconto(value)
                        }
                    }}
                    currencyconfig={{
                        locale: "pt-BR",
                        currencyCode: "BRL",
                        currencyDisplay: "symbol",
                        useGrouping: true,
                    }}
                />
                <Button onClick={()=>handleConfirmar(desconto)} variant="contained" color="primary" sx={{ margin: 2 }}>
                    <Check />
                    Confirmar
                </Button>
            </div>
        )
    }
    return (
        <Modal
            component={
                <Box>
                    <ToolbarModal
                        handleClose={handleClose}
                        title={title}
                        color="primary"
                        variantToobar="dense"
                        positionToolBar="relative"
                        elevation={1}
                    />
                    <Content />

                </Box>

            }
            handleClose={handleClose}
            open={show}
            width="xs"
            heigth="auto"
            handleOnKeyDown={() => { }}
        />
    );
}
export default DescontoModal;